import { axios } from '@/utils/request'
const getUpload = (params) => {
    return axios({
        url: '/fileserver/api/v1/upload',
        method: 'post',
        data: params
      })
}
const getBanner = (params) => {
    return axios({
        url: '/zf-api/img/banner',
        method: 'post',
        data: params
      })
}
const getAgreementSave= (params) => {
    return axios({
        url: '/zf-api/agreement/save',
        method: 'post',
        data: params
      })
}
const getMallCategory = (params) => {
    return axios({
        url: '/zf-api/mall/category_list',
        method: 'post',
        data: params
      })
}

const getSubList = (params) => {
    return axios({
        url: '/zf-api/mall/sub_list',
        method: 'post',
        data: params
      })
}
const getUserInfo = (params) => {
    return axios({
        url: '/zf-api/user/short_info',
        method: 'post',
        data: params
      })
}
const getSubInfo = (params) => {
    return axios({
        url: '/zf-api/mall/sub_info',
        method: 'post',
        data: params
      })
}

const getProductList = (params) => {
    return axios({
        url: '/zf-api/mall/product_list',
        method: 'post',
        data: params
      })
}

const getProductInfo = (params) => {
    return axios({
        url: '/zf-api/mall/product_info_list',
        method: 'post',
        data: params
      })
}


const getProductCategoryList= (params) => {
    return axios({
        url: '/zf-api/mall/product_category_list',
        method: 'post',
        data: params
      })
}
const getAgreementList = (params) => {
    return axios({
        url: '/zf-api/agreement/list',
        method: 'post',
        data: params
      })
}

const getCompanyInfo= (params) => {
    return axios({
        url: '/zf-api/company/info',
        method: 'post',
        data: params
      })
}
const getCertificationInfo = (params) => {
    return axios({
        url: '/zf-api/certification/info',
        method: 'post',
        data: params
      })
}
const getCertificationSave = (params) => {
    return axios({
        url: '/zf-api/certification/save',
        method: 'post',
        data: params
      })
}
const getRiskList = (params) => {
    return axios({
        url: '/zf-api/risk/v2/list',
        method: 'post',
        data: params
      })
}

const getRiskInfo= (params) => {
    return axios({
        url: '/zf-api/risk/risk_info',
        method: 'post',
        data: params
      })
}
const getSave= (params) => {
    return axios({
        url: '/zf-api/risk/v2/save',
        method: 'post',
        data: params
      })
}
// /zf-api/agreement/info 查询协议详情
const getAgreementInfo= (params) => {
    return axios({
        url: '/zf-api/agreement/infoV2',
        method: 'post',
        data: params
      })
}
// /zf-api/user_discount_coupon/list        我的优惠券      
const getUserDiscountCouponList= (params) => {
    return axios({
        url: '/zf-api/user_discount_coupon/list',
        method: 'post',
        data: params
      })
}
// /zf-api/order/query_list 订单列表
const getOrderQueryList= (params) => {
    return axios({
        url: '/zf-api/order/query_list',
        method: 'post',
        data: params
      })
}
// /zf-api/order/info 订单详情
const getOrderInfo= (params) => {
    return axios({
        url: '/zf-api/order/info',
        method: 'post',
        data: params
      })
}
// /zf-api/user_discount_coupon/use_list 可用的优惠券
const getUserDiscountCouponUseList= (params) => {
    return axios({
        url: '/zf-api/user_discount_coupon/use_list',
        method: 'post',
        data: params
      })
}
// /zf-api/order/update_state 修改订单状态
const getOrderUpdateState= (params) => {
    return axios({
        url: '/zf-api/order/update_state',
        method: 'post',
        data: params
      })
}
// /activity/dc_list 活动页优惠券列表
const getActivityDcList= (params) => {
    return axios({
        url: '/zf-api/activity/dc_list',
        method: 'post',
        data: params
      })
}
// /activity/info 活动详情
const getActivityInfo= (params) => {
    return axios({
        url: '/zf-api/activity/info',
        method: 'post',
        data: params
      })
}
// /discount_coupon/receive 用户领取优惠券 
const getDiscountCouponReceive= (params) => {
    return axios({
        url: '/zf-api/discount_coupon/receive',
        method: 'post',
        data: params
      })
}
const getCode = (params) => {
    return axios({
        url: '/zf-api/index/getcode',
        method: 'post',
        data: params
    })
}
const getCodelogin = (params) => {
    return axios({
        url: '/zf-api/index/codelogin',
        method: 'post',
        data: params
    })
}

const getAccountRegister = (params) => {
    return axios({
        url: '/zf-api/user_certification/account_register',
        method: 'post',
        data: params
    })
}

const getExtsign = (params) => {
    return axios({
        url: '/zf-api/user_certification/extsign',
        method: 'post',
        data: params
    })
}
// /zf-api/user_certification/order_type
const getCertificationOrderType = (params) => {
    return axios({
        url: '/zf-api/user_certification/order_type',
        method: 'post',
        data: params
    })
}

const getOrderSelectOne = (params) => {
    return axios({
        url: '/zf-api/order/select_one',
        method: 'post',
        data: params
    })
}
const getAccountRegisterV2 = (params) => {
    return axios({
        url: '/zf-api/user_certification/account_registerV2',
        method: 'post',
        data: params
    })
}
const getSaveV2= (params) => {
    return axios({
        url: '/zf-api/risk/v2/saveV2',
        method: 'post',
        data: params
      })
}
const getRiskInfoV2= (params) => {
    return axios({
        url: '/zf-api/risk/risk_infoV2',
        method: 'post',
        data: params
      })
}

const getExtsignV2 = (params) => {
    return axios({
        url: '/zf-api/user_certification/extsignV2',
        method: 'post',
        data: params
    })
}
// /zf-api/product/pro_info_key 根据组件key查商品
const proInfoKey = (params) => {
    return axios({
        url: '/zf-api/product/pro_info_key',
        method: 'post',
        data: params
    })
}
// /user/membership_details 会员详情
const membershipDetails = (params) => {
    return axios({
        url: '/zf-api/user/membership_details',
        method: 'post',
        data: params
    })
}
// /zf-api/user/product_list 会员商品列表
const productList = (params) => {
    return axios({
        url: '/zf-api/user/product_list',
        method: 'post',
        data: params
    })
}
// /zf-api/user/info
const userInfo = (params) => {
    return axios({
        url: '/zf-api/user/info',
        method: 'post',
        data: params
    })
}
// /user_certification/age_correction
// POST
// 合同年龄限制接口
const ageCorrection = (params) => {
    return axios({
        url: '/zf-api/user_certification/age_correction',
        method: 'post',
        data: params
    })
}
export default {
    getBanner,
    getMallCategory,
    getSubList,
    getSubInfo,
    getProductList,
    getProductInfo,
    getProductCategoryList,
    getAgreementList,
    getCompanyInfo,
    getCertificationInfo,
    getUserInfo,
    getCertificationSave,
    getRiskList,
    getRiskInfo,
    getSave,
    getUpload,
    getAgreementSave,
    getAgreementInfo,
    getUserDiscountCouponList,
    getOrderQueryList,
    getOrderInfo,
    getUserDiscountCouponUseList,
    getOrderUpdateState,
    getActivityDcList,
    getActivityInfo,
    getDiscountCouponReceive,
    getCode,
    getCodelogin,
    getAccountRegister,
    getExtsign,
    getCertificationOrderType,
    getOrderSelectOne,
    getAccountRegisterV2,
    getSaveV2,
    getRiskInfoV2,
    getExtsignV2,
    proInfoKey,
    membershipDetails,
    productList,
    userInfo,
    ageCorrection
}
